import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import { BadgeIcon, CaptureIcon, KeyIcon } from './icons';
import './styles.scss';

const cards = [
  {
    icon: BadgeIcon,
    numeral: '01',
    label: 'Model · Flat',
    title: 'Pricing that ignores your revenue',
    body:
      'Your software bill should not be a percentage of every dollar of work you do. Flat fees, published in CAD, month-to-month.',
    chips: ['$39 / user', '$599 / project', 'Free forever', 'Month-to-month'],
  },
  {
    icon: CaptureIcon,
    numeral: '02',
    label: 'Model · Field-first',
    title: "Works where Wi-Fi doesn't",
    body:
      'Offline mode for poor-connectivity sites, QR-coded locations, voice-to-text capture, and photo proof on every punch line.',
    chips: ['Offline mode', 'Site QR codes', 'Voice-to-text', 'Photo proof'],
  },
  {
    icon: KeyIcon,
    numeral: '03',
    label: 'Model · Open gates',
    title: 'Every sub, on the system',
    body:
      'Unlimited subcontractor accounts on every plan and two-minute onboarding. The record only works if the whole jobsite writes to it.',
    chips: ['Free sub accounts', '2-min onboarding', 'iOS + Android', 'Every plan'],
  },
];

export default function FieldFirstSection() {
  return (
    <section className="plh-different">
      <Reveal className="plh-lead">
        <p className="plh-eyebrow">How ProjectLoop is different</p>
        <h2>
          <span className="plh-chapter">03 —</span> Built for the slab,{' '}
          <span className="plh-accent">not the boardroom.</span>
        </h2>
      </Reveal>
      <div className="plh-different__grid">
        {cards.map((card, idx) => {
          const Icon = card.icon;
          return (
            <Reveal className="plh-model" key={card.numeral} delay={idx * 90}>
              <span className="plh-model__numeral" aria-hidden="true">
                {card.numeral}
              </span>
              <span className="plh-model__icon" aria-hidden="true">
                <Icon />
              </span>
              <p className="plh-model__label plh-mono">{card.label}</p>
              <h3>{card.title}</h3>
              <p className="plh-model__body">{card.body}</p>
              <div className="plh-model__chips">
                {card.chips.map((chip) => (
                  <span key={chip}>{chip}</span>
                ))}
              </div>
            </Reveal>
          );
        })}
      </div>
      <Reveal className="plh-different__banner" delay={120}>
        <p>
          Run a real project with your real crews. If we don&rsquo;t pay for ourselves before day
          60 — <span className="plh-accent">walk away.</span>
        </p>
        <Link to="/signup" className="pl-btn pl-btn--ghost">
          Start free trial
        </Link>
      </Reveal>
    </section>
  );
}
